export default {
  UPDATE_ENVELOPE_CONFIG: 'update-envelope',
  DELETE_DOCUMENT: 'delete-document',
  DELETE_DOCUMENT_BY_ASSET_ID: 'delete-document-by-asset-id',
  UPLOAD_DOCUMENT: 'upload-document',
  CREATE_FROM_ASSET_ID: 'create-from-asset-id',
  TRIGGER_DOCUMENT_GENERATION: 'trigger-document-generation',

  REQUEST_SIGNATURE: 'request-signature',
  DOWNLOAD_SIGNED_FILES: 'download-signed-files',
  CANCEL_SEND_REQUEST: 'cancel-send-request',
  UPDATE_PROGRESS_STATUS: 'update-progress-status',

  GET_LOGO_PRESIGNED_URL: 'get-logo-presigned-url',
  DELETE_LOGO: 'delete-logo',

  UPDATE_DOCUMENT: 'update-document',

  DOWNLOAD_GENERATED_DOCUMENT: 'download-generated-document',
  DOWNLOAD_GENERATED_DOCUMENTS: 'download-generated-documents',

  SEND_VERIFICATION_EMAIL: 'send-verification-email',
  REQUEST_SIGN_BY_ME: 'request-sign-by-me',
  SELECT_TEMPLATE_GALLERY_TEMPLATE: 'select-template-gallery-template',

  UPDATE_USE_FILE_COLUMN: 'UPDATE_USE_FILE_COLUMN',
  UPDATE_PRESIGNED_FILE_COLUMN: 'UPDATE_PRESIGNED_FILE_COLUMN',

  TEMPLATE_GALLERY_RENAME_TEMPLATE: 'template-gallery-rename-template',
  TEMPLATE_GALLERY_VALIDATE_DELETE_TEMPLATE:
    'template-gallery-validate-delete-template',
  TEMPLATE_GALLERY_DELETE_TEMPLATE: 'template-gallery-delete-template',
  TEMPLATE_GALLERY_DUPLICATE_TEMPLATE: 'template-gallery-duplicate-template',
  TEMPLATE_GALLERY_SELECT_TEMPLATE: 'template-gallery-select-template',

  RESET_SIGNING_PROCESS: 'reset-signing-process',
  CONFIGURE_DOMAIN: 'configure-domain',
  MARK_DNS_ADDED: 'mark-dns-as-added',
  VALIDATE_DNS: 'validate-dns',
  DELETE_DOMAIN: 'delete-domain',

  COPY_INDIVIDUAL_SIGNING_LINK: 'copy-individual-signing-link',
};
